import { render, staticRenderFns } from "./BacklinksManagementPopup.vue?vue&type=template&id=29b53122&scoped=true&lang=html"
import script from "./BacklinksManagementPopup.vue?vue&type=script&lang=js"
export * from "./BacklinksManagementPopup.vue?vue&type=script&lang=js"
import style0 from "./BacklinksManagementPopup.vue?vue&type=style&index=0&id=29b53122&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b53122",
  null
  
)

export default component.exports